
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    facetData: {
      type: Object,
      default: () => ({}),
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedCheckbox: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchPrices: 'search/getSearchPrices',
      vxActivePriceFacets: 'search/getActivePriceFacets',
    }),
    filterValue() {
      return `filter.${this.facetData.field}.low=${this.filterData.low}&filter.${this.facetData.field}.high=${this.filterData.high}`
    },
    searchPrices: {
      get() {
        return this.vxActivePriceFacets
      },
      set(value) {
        this.vxResetSearchResults('filtering')
        this.setSearchPrices(value)
        this.vxQuerySearchspring()
      },
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxResetSearchResults: 'search/resetSearchResults',
      vxSetSearchParameters: 'search/setSearchParameters',
      vxSetActivePriceFacet: 'search/setActivePriceFacet',
    }),
    setSearchPrices(value) {
      this.vxSetActivePriceFacet(value)

      const rangePrices = value.reduce(
        (acc, range) => {
          const rangeSplit = range.split('&')
          const rangeLow =
            rangeSplit[0].split('=')[1] !== '*'
              ? rangeSplit[0].split('=')[1]
              : 0
          const rangeHigh =
            rangeSplit[1].split('=')[1] !== '*'
              ? rangeSplit[1].split('=')[1]
              : 500

          acc.low.push(rangeLow)
          acc.high.push(rangeHigh)
          return acc
        },
        { low: [], high: [] }
      )

      const priceLow = Math.min(...rangePrices.low)
      const priceHigh = Math.max(...rangePrices.high)

      this.vxSetSearchParameters({
        prices: {
          low: parseInt(priceLow),
          high: parseInt(priceHigh),
        },
      })
    },
  },
}
